export default {
  Atm: {
    is: 'Hraðbanki',
    en: 'Atm',
  },
  CurrencyAtm: {
    is: 'Gjaldeyrir',
    en: 'Currency',
  },
  DepositAtm: {
    is: 'Innlögn',
    en: 'Deposit',
  },
  CoinRollAtm: {
    is: 'Myntrúllusjálfsali',
    en: 'Coin roll dispenser',
  },
  CoinCounterAtm: {
    is: 'Mynttalningarvél',
    en: 'Coin count machine',
  },
  GiftCardAtm: {
    is: 'Gjafakortasjálfsali',
    en: 'Gift card',
  },
  CorporateDepositAtm: {
    is: 'Fyrirtækjainnlegg',
    en: 'Corporate deposit',
  },
};
